import { render, staticRenderFns } from "./Ujo.vue?vue&type=template&id=eb212890&scoped=true"
import script from "./Ujo.vue?vue&type=script&lang=js"
export * from "./Ujo.vue?vue&type=script&lang=js"
import style0 from "./Ujo.vue?vue&type=style&index=0&id=eb212890&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb212890",
  null
  
)

export default component.exports